import { doMutation } from "../../core-module/util/graphqlHelper";

export const createOrUpdateTrainingRegistrationInvoice = (id, status) => {
  const mutation = require("../api/mutation/createOrUpdateTrainingRegistrationInvoice.gql");
  const variables = {
    input: { _id: id, status: status },
  };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      return { data: data.createOrUpdateTrainingRegistrationInvoice };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
